export default "__VITE_ASSET__4daf0365__"